'use client';

import { useAtomValue } from 'jotai';

import { stack } from '@flipster/styled-system/patterns';

import { filteredGlossaryTermsAtom } from '../jotai';
import TermListItem from './term-list-item';

const TermList = () => {
  const filteredGlossaryTerms = useAtomValue(filteredGlossaryTermsAtom);
  return (
    <ul className={stack({ gap: 20, tablet: { gap: 26 } })}>
      {filteredGlossaryTerms.map((glossaryTerm) => (
        <li key={glossaryTerm.sys.id}>
          <TermListItem glossaryTerm={glossaryTerm} />
        </li>
      ))}
    </ul>
  );
};

export default TermList;
